import "core-js/modules/es.array-buffer.constructor";
import "core-js/modules/es.array-buffer.slice";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.typed-array.uint8-array";
import "core-js/modules/es.typed-array.uint16-array";
import "core-js/modules/es.typed-array.copy-within";
import "core-js/modules/es.typed-array.every";
import "core-js/modules/es.typed-array.fill";
import "core-js/modules/es.typed-array.filter";
import "core-js/modules/es.typed-array.find";
import "core-js/modules/es.typed-array.find-index";
import "core-js/modules/es.typed-array.for-each";
import "core-js/modules/es.typed-array.includes";
import "core-js/modules/es.typed-array.index-of";
import "core-js/modules/es.typed-array.iterator";
import "core-js/modules/es.typed-array.join";
import "core-js/modules/es.typed-array.last-index-of";
import "core-js/modules/es.typed-array.map";
import "core-js/modules/es.typed-array.reduce";
import "core-js/modules/es.typed-array.reduce-right";
import "core-js/modules/es.typed-array.reverse";
import "core-js/modules/es.typed-array.set";
import "core-js/modules/es.typed-array.slice";
import "core-js/modules/es.typed-array.some";
import "core-js/modules/es.typed-array.sort";
import "core-js/modules/es.typed-array.subarray";
import "core-js/modules/es.typed-array.to-locale-string";
import "core-js/modules/es.typed-array.to-string";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/Users/mpagalan/Projects/ormoc-ctzn-form-google/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
var key = {
  alg: "A256CBC",
  ext: true,
  k: "NGg3e8V-eADmpNw7hwl3oFHNt0YVq-m6E_pTDjnoaXY",
  key_ops: ["encrypt"],
  kty: "oct"
};
export default {
  crypto: window.crypto || window.msCrypto,
  iv: null,
  str2ab: function str2ab(str) {
    var buf = new ArrayBuffer(str.length * 2); // 2 bytes for each char

    var bufView = new Uint16Array(buf);

    for (var i = 0, strLen = str.length; i < strLen; i++) {
      bufView[i] = str.charCodeAt(i);
    }

    return buf;
  },
  ab2str: function ab2str(buf) {
    return String.fromCharCode.apply(null, new Uint16Array(buf));
  },
  str2ab8: function str2ab8(str) {
    var buf = new ArrayBuffer(str.length);
    var bufView = new Uint8Array(buf);

    for (var i = 0, strLen = str.length; i < strLen; i++) {
      bufView[i] = str.charCodeAt(i);
    }

    return buf;
  },
  ab82str: function ab82str(buff) {
    return String.fromCharCode.apply(null, new Uint8Array(buff));
  },
  ab2encodeStr: function ab2encodeStr(ab) {
    return btoa(this.ab82str(ab));
  },
  strDecode2ab: function strDecode2ab(st) {
    return this.str2ab8(atob(st));
  },
  getKey: function getKey() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.crypto.subtle.importKey("jwk", key, {
                name: "AES-CBC",
                length: 256
              }, true, ["encrypt"]);

            case 2:
              return _context.abrupt("return", _context.sent);

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  hide: function hide(data) {
    var _this2 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      var key, text;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return _this2.getKey();

            case 2:
              key = _context2.sent;
              _this2.iv = _this2.crypto.getRandomValues(new Uint8Array(16));
              _context2.next = 6;
              return _this2.crypto.subtle.encrypt({
                name: "AES-CBC",
                iv: _this2.iv
              }, key, _this2.str2ab8(data));

            case 6:
              text = _context2.sent;
              return _context2.abrupt("return", text);

            case 8:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }))();
  }
};